import { useState, useEffect } from 'react';
export function useOnScreen({ ref, root, rootMargin = '0px', threshold, fallback = true, pause = false, }) {
    // State and setter for storing whether element is visible
    const [intersecting, setIntersecting] = useState(false);
    const element = ref ? ref.current : null;
    useEffect(() => {
        if (pause) {
            return;
        }
        if (!('IntersectionObserver' in window)) {
            // can't detect, so pretend its always visible
            setIntersecting(fallback);
            return;
        }
        let isMounted = true;
        // If IntersectionObserver is not in window
        //  intersecting set to fallback and return
        // eslint-disable-next-line compat/compat
        const observer = new IntersectionObserver(
        /* istanbul ignore next */
        ([entry]) => {
            // Update our state when observer callback fires
            if (isMounted)
                setIntersecting(entry.isIntersecting);
        }, {
            root: root ? root.current : null,
            rootMargin,
            threshold,
        });
        /* istanbul ignore next */
        if (element) {
            observer.observe(element);
        }
        return () => {
            isMounted = false;
            if (element) {
                observer.unobserve(element);
            }
        };
    }, [element, root, rootMargin, threshold, fallback, pause]);
    return intersecting;
}
/**
 * source: https://usehooks.com/useOnScreen/
 */
